export enum PRIMARY_CARE_LIBRARY_ASSET_KEYS {
  BACK_GRAY_ICON = 'BACK_GRAY_ICON',
  INFO_ICON = 'INFO_ICON',
  SERVICE_DOWN_ICON = 'SERVICE_DOWN_ICON',
}

export type PrimaryCareProviderAssets = Record<
  PRIMARY_CARE_LIBRARY_ASSET_KEYS,
  unknown
>;
